import { Container, Pagination, useBreakpoint } from '@melio/penny';
import { PaginationResponsePagination, UsePaginatedCollection } from '@melio/platform-api';
import { useEffect } from 'react';

import { usePayDashboardPagination } from './PayDashboardPaginationProvider';

export const PayDashboardPagination = ({
  paginatedCollection,
  isVisible,
}: {
  paginatedCollection: UsePaginatedCollection<{ data: unknown[]; pagination: PaginationResponsePagination }>;
  isVisible: boolean;
}) => {
  const { isExtraSmallScreen: isMobile } = useBreakpoint();
  const { resetToFirstPage, setPreviousPage, setNextPage, currentPage, pageSize } = usePayDashboardPagination();

  const { data: paginationResult, fetchPreviousPage, fetchNextPage, fetchFirstPage } = paginatedCollection;
  const { data, pagination } = paginationResult ?? {};

  useEffect(() => {
    // in case we delete the only item in the last page, we need to fetch the first page
    if (data?.length === 0 && pagination?.totalCount && pagination.totalCount > 0) {
      resetToFirstPage();
      fetchFirstPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleFetchPreviousPage = () => {
    setPreviousPage();
    fetchPreviousPage();
  };

  const handleFetchNextPage = () => {
    setNextPage();
    fetchNextPage();
  };

  const handlePageChange = (newPageNumber: number) => {
    if (newPageNumber > currentPage) {
      handleFetchNextPage();
    } else {
      handleFetchPreviousPage();
    }
  };

  return isVisible ? (
    <Container justifyContent={isMobile ? 'flex-start' : 'flex-end'}>
      <Pagination
        data-testid="pay-dashboard-pagination-controls"
        pageSize={pageSize}
        totalItems={pagination?.totalCount ?? 0}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </Container>
  ) : null;
};
